export default {"src":"/_next/static/media/contact.1f7f05fe.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};